(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stem-routine-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.stem-routine-form')) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const label = button.textContent;
    const status = form.querySelector('.stem-routine-status');
    button.disabled = true;
    button.textContent = form.dataset.busy;
    form.setAttribute('aria-busy', 'true');
    status.textContent = '';
    const items = Array.from(form.querySelectorAll('input[name$="[id]"]')).map(input => ({id: Number(input.value), quantity: 1}));
    try {
      const response = await fetch(form.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || form.dataset.error);
      window.location.assign(form.dataset.cartUrl);
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
      button.disabled = false;
      button.textContent = label;
      form.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
